module.exports = __webpack_public_path__ + "static/media/time.a80e4e98.png";